import _ from 'underscore'
import CustomerProjectSelection from '../../../CustomerProjectSelection'
import {filterEntitiesBySearch} from '../../common/utils'
import {nameComparator} from '../../../atUtils'
import CustomerNode from './CustomerNode'
import ProjectNode from './ProjectNode'
import OtherProjectsNode from './OtherProjectsNode'

export const buildVisibleCustomers = (filterCPSelection, customers, projects, openCustomerId, openProjectId) => {
    const result = []
    const cpSelection = CustomerProjectSelection.fromPlainObject(filterCPSelection)

    const sortedCustomers = Object.values(customers).sort(nameComparator)
    const sortedProjects = Object.values(projects).sort(nameComparator)

    const projectsByCustomer = _.groupBy(sortedProjects, 'customerId')

    sortedCustomers.forEach(customer => {
        const customerIncluded = cpSelection.includesCustomer(customer) || openCustomerId === customer.id
        const customerProjects = projectsByCustomer[customer.id]
                                 ? projectsByCustomer[customer.id].filter(p => cpSelection.includesProject(p)
                                                                               || openProjectId === p.id)
                                 : []

        if (customerIncluded || customerProjects.length > 0) {
            result.push({
                customerId: customer.id,
                projectIds: customerProjects.map(p => p.id)
            })
        }
    })

    return result
}

export const buildVisibleCustomersFiltered = (filterCPSelection, customers, projects, openCustomerId, openProjectId,
    recentlyCreatedCustomerIds, recentlyCreatedProjectIds, text) => {

    if (!text)
        return null

    const result = []
    const resultMap = {}
    const cpSelection = CustomerProjectSelection.fromPlainObject(filterCPSelection)

    const sortedCustomers = Object.values(customers)
        .filter(customer => !recentlyCreatedCustomerIds.includes(customer.id) || openCustomerId === customer.id)
        .sort(nameComparator)

    const sortedProjects = Object.values(projects)
        .filter(project => !recentlyCreatedProjectIds.includes(project.id)
                       || openCustomerId === project.customerId
                       || openProjectId === project.id
        )
        .sort(nameComparator)

    const getOrCreateVisibleCustomerData = (customerId) => {
        let visibleCustomerData = resultMap[customerId]
        if (!visibleCustomerData) {
            visibleCustomerData = {
                customerId: customerId,
                projectIds: [],
                otherProjectIds: []
            }
            result.push(visibleCustomerData)
            resultMap[customerId] = visibleCustomerData
        }
        return visibleCustomerData
    }

    recentlyCreatedCustomerIds.forEach(cId => {
        getOrCreateVisibleCustomerData(cId)
    })

    recentlyCreatedProjectIds.forEach(pId => {
        const visibleCustomerData = getOrCreateVisibleCustomerData(projects[pId].customerId)
        visibleCustomerData.projectIds.push(pId)
    })

    filterEntitiesBySearch(sortedCustomers, text).forEach(customer => {
        if (cpSelection.includesCustomer(customer, true) || openCustomerId === customer.id)
            getOrCreateVisibleCustomerData(customer.id)
    })

    filterEntitiesBySearch(sortedProjects, text).forEach(project => {
        if (cpSelection.includesProject(project) || openProjectId === project.id || openCustomerId === project.customerId) {
            const visibleCustomerData = getOrCreateVisibleCustomerData(project.customerId)
            visibleCustomerData.projectIds.push(project.id)
        }
    })

    if (text) {
        Object.values(resultMap).forEach(visibleCustomerData => {
            const projectsByCustomer = _.groupBy(sortedProjects, 'customerId')

            const customerProjects = projectsByCustomer[visibleCustomerData.customerId] ? projectsByCustomer[visibleCustomerData.customerId] : []
            customerProjects.filter(project => cpSelection.includesProject(project)).forEach(project => {
                if (!visibleCustomerData.projectIds.find(id => Number(id) === project.id)) {
                    visibleCustomerData.otherProjectIds.push(project.id)
                }
            })
        })
    }

    return result
}

export const getVisibleCustomerIds = (nodes) => {
    let customerNodes = nodes.array.filter((node) => node instanceof CustomerNode)
    return customerNodes.map((customerNode) => customerNode.customer.id)
}

export const getVisibleProjectIds = (nodes) => {
    let projectIds = []

    let cursorInOtherProjectsNode = false
    let shouldSkipOtherProjectsNode = false

    for (let i = 0; i < nodes.array.length; i++) {
        const node = nodes.array[i]

        const isProjectNode = node instanceof ProjectNode
        const isOtherProjectNode = node instanceof OtherProjectsNode
        const isProjectNodeInOtherSelection = cursorInOtherProjectsNode && !shouldSkipOtherProjectsNode

        if (isOtherProjectNode) {
            cursorInOtherProjectsNode = true
            shouldSkipOtherProjectsNode = node.state.collapsed
        } else if (!isProjectNode) {
            cursorInOtherProjectsNode = false
        } else if (isProjectNodeInOtherSelection) {
            projectIds.push(node.project.id)
        } else if (!cursorInOtherProjectsNode && isProjectNode) {
            projectIds.push(node.project.id)
        }
    }

    return projectIds
}




// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/utils.js